<template>
  <div>
    <div class="search-flex">
      <!-- 搜索框 -->
      <div>

        <!-- 生成时间范围(必选，默认最近30天) -->
        <el-date-picker v-model="searchParams.createTime" :clearable="false" type="daterange" range-separator="至"
          start-placeholder="生成时间开始" end-placeholder="生成时间结束" value-format="yyyy-MM-dd" size="small"
          style="width: 250px !important;height:32px !important;margin-right: 20px;" format="yyyy-MM-dd"></el-date-picker>
        <!-- 激活时间范围(非必选) -->
        <el-date-picker v-model="searchParams.redeemTime" type="daterange" range-separator="至" start-placeholder="激活开始日期"
          end-placeholder="激活结束日期" value-format="yyyy-MM-dd" clearable size="small"
          style="width: 250px !important;height:32px !important;;margin-right: 20px;"
          format="yyyy-MM-dd"></el-date-picker>
        <!-- 激活码/激活手机号/生成批次ID -->
        <el-input class="search_input" style="width: 250px !important;" clearable placeholder="激活码/激活手机号/生成批次ID"
          size="small" v-model="searchParams.cdkeyOrMobileOrConfigId"></el-input>
        <el-input class="search_input" clearable placeholder="激活码名称" size="small"
          v-model="searchParams.cdkeyName"></el-input>
        <!-- 状态 -->
        <el-select class="search_input" clearable placeholder="状态" size="small" v-model="searchParams.status">
          <!-- 状态：0-未激活，1-已激活，2-已冻结，3-已作废 4-已过期-->
          <el-option label="未激活" :value="0"></el-option>
          <el-option label="已激活" :value="1"></el-option>
          <el-option label="已冻结" :value="2"></el-option>
          <el-option label="已作废" :value="3"></el-option>
        </el-select>

      </div>
      <div style="flex-wrap: nowrap;">
        <!-- 搜索按钮 -->
        <el-button v-auth="'ACTIVE_CODE_LIST_SEARCH'" type="primary" size="small" @click="search">搜索</el-button>
        <!-- 导出按钮 -->
        <el-button v-auth="'ACTIVE_CODE_LIST_EXPORT'" size="small" @click="exportExcel">导出激活码财务订单</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Message from "@/components/Message"
export default {
  inject: ["searchParams", "getList"],
  name: "WebSaaSSearch",

  data() {
    return {};
  },

  methods: {
    /** 搜索 */
    search() {
      console.log("搜索", this.searchParams);
      this.getList();
      Message.success("搜索成功");
    },
    /** 导出 */
    exportExcel() {
      this.$emit('exportExcel')
    },
  },
};
</script>

<style lang="scss" scoped>
.search-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search_input {
  width: 160px !important;
  margin: 10px 20px 0 0;
}

::v-deep .el-select__tags {
  flex-wrap: nowrap !important;
}
</style>